import React from "react";
import "../styles/Efectos.css";

const Efectos = () => {
  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="efectos-hero-section">
        <div className="efectos-hero-content">
          <div className="efectos-hero-container">
            <div className="efectos-hero-card">
              <div className="efectos-hero-grid">
                <div className="efectos-hero-left">
                  <h1 className="efectos-hero-title">
                    Los <span className="efectos-hero-title-gradient">Sismos</span> y sus Efectos
                  </h1>
                </div>
                <div className="efectos-hero-right">
                  <p className="efectos-hero-description">
                    Información detallada sobre los fenómenos que causan los sismos y sus efectos en la superficie
                    terrestre. Conoce los tipos de fallas, ondas sísmicas, y factores que contribuyen a los daños
                    causados por los terremotos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* El Fenómeno de los Sismos Section */}
      <section className="efectos-fenomeno-section">
        <div className="efectos-fenomeno-container">
          <div className="efectos-fenomeno-content">
            <div className="efectos-fenomeno-text">
              <h2 className="efectos-fenomeno-title">
                <span className="efectos-fenomeno-title-gradient">El Fenómeno</span> de los Sismos
              </h2>
              <p className="efectos-fenomeno-description">
                Los sismos son fenómenos naturales que afectan a la humanidad
              </p>
              <p className="efectos-fenomeno-text">
                Con frecuencia los medios de comunicación ponen de actualidad ciudades como Tangshan (1976), Guatemala
                (1976), México (1985), El Salvador (1986), Armenia (1989) o Kobe (1995), entre muchas otras, asoladas
                por grandes terremotos que les causan considerables daños materiales y un gran número de víctimas. La
                superficie de la Tierra, considerada por el hombre como un soporte firme de su actividad, es sacudida
                por grandes vibraciones ante las cuales se muestra como un frágil material.
              </p>
              <p className="efectos-fenomeno-text">
                Los sismos son probablemente las catástrofes ante las cuales el hombre se siente más indefenso y
                aterrado. Ocurren sin advertencia alguna, y aun cuando ningún sismo dura por más de 30 a 50 segundos en
                su máxima intensidad este tiempo es más que suficiente para causar graves daños al hombre y sus centros
                de población.
              </p>
            </div>
            <div className="efectos-fenomeno-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/fuertes.jpg`} alt="Efectos de sismos fuertes" />
            </div>
          </div>
        </div>
      </section>

      {/* Tipos de Fallas Section */}
      <section className="efectos-fallas-section">
        <div className="efectos-fallas-container">
          <div className="efectos-fallas-content">
            <div className="efectos-fallas-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/Tipofallas.jpg`} alt="Tipos de fallas geológicas" />
            </div>
            <div className="efectos-fallas-text">
              <h2 className="efectos-fallas-title">
                <span className="efectos-fallas-title-gradient">Tipos de Fallas</span> Geológicas
              </h2>
              <p className="efectos-fallas-description">Clasificación de las fracturas que causan los sismos</p>
              <p className="efectos-fallas-text">
                Una falla es una fractura que separa dos bloques de roca, los cuales pueden deslizarse uno respecto al
                otro en forma paralela a la fractura. A cada deslizamiento repentino de estos bloques se produce un
                sismo. Existen tres tipos de fallas: fallas de rumbo o transcurrentes, fallas normales y fallas
                inversas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* La Falla de San Andrés Section */}
      <section className="efectos-sanandres-section">
        <div className="efectos-sanandres-container">
          <div className="efectos-sanandres-content">
            <div className="efectos-sanandres-text">
              <h2 className="efectos-sanandres-title">
                La Falla de <span className="efectos-sanandres-title-gradient">San Andrés</span>
              </h2>
              <p className="efectos-sanandres-description">Una de las fallas más famosas del mundo</p>
              <p className="efectos-sanandres-text">
                El 18 de abril de 1906 la falla de San Andrés llamó dramáticamente la atención del mundo con un
                devastador terremoto de magnitud 8.1 en San Francisco, California. Esta gigantesca falla es el área de
                contacto, o frontera, entre dos de las grandes placas tectónicas: la del Pacífico y la de Norteamérica.
              </p>
            </div>
            <div className="efectos-sanandres-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/sanfran.jpg`} alt="Falla de San Andrés" />
            </div>
          </div>
        </div>
      </section>

      {/* Ondas Elásticas Section */}
      <section className="efectos-ondas-section">
        <div className="efectos-ondas-container">
          <div className="efectos-ondas-content">
            <div className="efectos-ondas-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/fallas2020.jpg`} alt="Ondas elásticas" />
            </div>
            <div className="efectos-ondas-text">
              <h2 className="efectos-ondas-title">
                Ondas <span className="efectos-ondas-title-gradient">Elásticas</span>
              </h2>
              <p className="efectos-ondas-description">Cómo se propaga la energía sísmica</p>
              <p className="efectos-ondas-text">
                La energía liberada durante un sismo se propaga por la Tierra en forma de ondas elásticas denominadas
                como ondas P, ondas S y ondas superficiales de Love y Rayleigh.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tipos de Sismos Section */}
      <section className="efectos-tipos-section">
        <div className="efectos-tipos-container">
          <div className="efectos-tipos-content">
            <div className="efectos-tipos-text">
              <h2 className="efectos-tipos-title">
                <span className="efectos-tipos-title-gradient">Tipos</span> de Sismos
              </h2>
              <p className="efectos-tipos-description">Clasificación según su origen</p>
              <p className="efectos-tipos-text">
                La causa de un sismo es la liberación súbita de energía dentro de una región confinada del interior de
                la Tierra. Atendiendo al tipo de energía liberada durante un proceso sísmico, los sismos pueden ser
                tectónicos o volcánicos.
              </p>
            </div>
            <div className="efectos-tipos-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/fuego.jpg`} alt="Tipos de sismos" />
            </div>
          </div>
        </div>
      </section>

      {/* Información Adicional Section */}
      <section className="efectos-info-section">
        <div className="efectos-info-container">
          <div className="efectos-info-content">
            <div className="efectos-info-header">
              <h2 className="efectos-info-main-title">
                Información <span className="efectos-info-main-title-gradient">Adicional</span>
              </h2>
              <p className="efectos-info-main-description">Conceptos importantes sobre sismicidad y tectónica</p>
            </div>

            <div className="efectos-info-grid">
              <div className="efectos-info-item">
                <div className="efectos-info-image">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/sfx.jpg`} alt="Enjambres y réplicas" />
                </div>
                <div className="efectos-info-text">
                  <h3 className="efectos-info-title">Enjambres y Réplicas</h3>
                  <p className="efectos-info-description">
                    Frecuentemente se observa que siguiendo a un fuerte sismo ocurre una serie de sismos pequeños a los
                    cuales se les ha dado el nombre de réplicas.
                  </p>
                </div>
              </div>

              <div className="efectos-info-item">
                <div className="efectos-info-image">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/placas.jpg`} alt="Tectónica de placas" />
                </div>
                <div className="efectos-info-text">
                  <h3 className="efectos-info-title">Sismos y Tectónica de Placas</h3>
                  <p className="efectos-info-description">
                    Los epicentros de los sismos que ocurren a diario en todo el mundo no se distribuyen aleatoriamente
                    sobre la superficie de la Tierra. La actividad sísmica global se concentra en bandas o zonas
                    estrechas, continuas y sinuosas, las cuales definen las fronteras de alrededor de las 15 o más
                    placas tectónicas que constituyen la parte más superficial de la Tierra.
                  </p>
                </div>
              </div>

              <div className="efectos-info-item">
                <div className="efectos-info-image">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/racm_efectodesitio-1-01.jpg`}
                    alt="Factores de daños"
                  />
                </div>
                <div className="efectos-info-text">
                  <h3 className="efectos-info-title">Factores que Contribuyen a los Daños</h3>
                  <p className="efectos-info-description">
                    Los daños causados por un terremoto son el resultado de factores tales como la magnitud del
                    terremoto, la duración del movimiento del suelo, el tipo de suelo y el tipo de construcción.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Magnitud e Intensidad Section */}
      <section className="efectos-magnitud-section">
        <div className="efectos-magnitud-container">
          <div className="efectos-magnitud-content">
            <div className="efectos-magnitud-text">
              <h2 className="efectos-magnitud-title">
                <span className="efectos-magnitud-title-gradient">Magnitud e Intensidad</span> de un Sismo
              </h2>
              <p className="efectos-magnitud-description">Medición y clasificación de los terremotos</p>
              <p className="efectos-magnitud-text">
                La magnitud es un parámetro que indica el tamaño relativo de los sismos, y está, por lo tanto,
                relacionada con la cantidad de energía liberada en la fuente del sismo.
              </p>
            </div>
            <div className="efectos-magnitud-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/intensidad-1.jpg`} alt="Magnitud e intensidad" />
            </div>
          </div>
        </div>
      </section>

      {/* Riesgo Sísmico Section */}
      <section className="efectos-riesgo-section">
        <div className="efectos-riesgo-container">
          <div className="efectos-riesgo-content">
            <div className="efectos-riesgo-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/riesgo-1.jpeg`} alt="Riesgo sísmico" />
            </div>
            <div className="efectos-riesgo-text">
              <h2 className="efectos-riesgo-title">
                <span className="efectos-riesgo-title-gradient">Riesgo</span> Sísmico
              </h2>
              <p className="efectos-riesgo-description">Evaluación del peligro sísmico</p>
              <p className="efectos-riesgo-text">
                Se considera como riesgo sísmico la probabilidad del daño a las construcciones y el número de personas
                que resultaron lesionadas o muertas en el caso de un fuerte sismo.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Efectos;
